<template>
  <b-modal
    :visible="value"
    title="Thêm mới kpi"
    centered
    @hide="closeModal"
    ignore-enforce-focus-selector="input"
  >
    <div class="row">
      <div class="col-md-12">
        <p class="text-danger" v-show="messError">
          <i class="bx bx-error-alt"></i> {{ messError }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Loại dịch vụ<span class="text-red">(*)</span></label>
          <Select2
            v-model="params.typeService"
            :options="serviceTypeOption"
            placeholder="Loại dịch vụ"
            @change="changeServiceTypeOption"
          >
          </Select2>
          <p class="text-red" v-if="arrError.typeService">Loại dịch vụ không được trống</p>
        </div>
        <div class="form-group">
          <label>Dịch vụ<span class="text-red">(*)</span></label>
          <Select2 v-model="params.service" :options="serviceOption" placeholder="Dịch vụ">
          </Select2>
          <p class="text-red" v-if="arrError.service">Dịch vụ không được trống</p>
        </div>
        <div class="form-group">
          <label>Vùng<span class="text-red">(*)</span></label>
          <Select2 v-model="params.regionId" :options="optionRegion" placeholder="Vùng"> </Select2>
          <p class="text-red" v-if="arrError.regionId">Vùng không được trống</p>
        </div>
        <div class="form-group">
          <label>CVKD<span class="text-red">(*)</span></label>
          <Select2 v-model="params.saleId" :options="optionSaleIds" placeholder="Chọn Merchant">
          </Select2>
          <p class="text-red" v-if="arrError.saleId">CVKD không được trống</p>
        </div>

        <div class="form-group">
          <label>Email merchant<span class="text-red">(*)</span></label>
          <!-- <input v-model="params.merchantEmail" placeholder="Email merchant" /> -->
          <Select2
            v-model="params.merchantEmail"
            :settings="mcSettings"
            placeholder="Email merchant"
            @change="contractInfo"
          >
          </Select2>
          <p class="text-red" v-if="arrError.merchantEmail">Email merchant không đúng định dạng</p>
        </div>
        <div class="form-group">
          <label>Ghi chú</label>
          <input v-model="params.note" placeholder="Ghi chú" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Serial<span class="text-red">(*)</span></label>
          <input v-model="params.serial" placeholder="Serial" />
          <p class="text-red" v-if="arrError.serial">Serial không được trống</p>
        </div>
        <div class="form-group">
          <label
            >Mã hợp đồng<span class="text-red">(*)</span>
            {{ loadContract ? 'Đang tải...' : '' }}</label
          >
          <!-- <input v-model="params.contractCode" placeholder="Mã hợp đồng" /> -->
          <Select2
            v-model="params.contractCode"
            :options="infoContract"
            :disabled="loadContract || infoContract.length === 0"
            :placeholder="'Mã hợp đồng'"
            @change="getDetailContract"
          >
          </Select2>
          <p class="text-red" v-if="arrError.contractCode">Mã hợp đồng không được trống</p>
        </div>
        <div class="form-group">
          <label
            >Mã phụ lục<span class="text-red">(*) </span> {{ loadPl ? 'Đang tải...' : '' }}</label
          >
          <!-- <input v-model="params.appendixCode" placeholder="Mã phụ lục" /> -->
          <Select2
            v-model="params.appendixCode"
            :options="opitonAppendixTrans"
            :disabled="loadPl || opitonAppendixTrans.length === 0"
            :placeholder="'Mã phụ lục'"
            @change="getAppendix"
          >
          </Select2>
          <p class="text-red" v-if="arrError.appendixCode">Mã phụ lục không được trống</p>
        </div>
        <div class="form-group">
          <label
            >Mã phiếu thu<span class="text-red">(*) </span> {{ loadPT ? 'Đang tải...' : '' }}</label
          >
          <!-- <input v-model="params.receiptCode" placeholder="Mã phiếu thu" /> -->
          <Select2
            v-model="params.receiptCode"
            :options="optionAppendix"
            :disabled="loadPT || optionAppendix.length === 0"
            :placeholder="'Mã phiếu thu'"
          >
          </Select2>
          <p class="text-red" v-if="arrError.receiptCode">Mã phiếu thu không được trống</p>
        </div>
        <div class="form-group">
          <label>Số kpi<span class="text-red">(*)</span></label>
          <input v-model="params.kpi" placeholder="Số kpi" />
          <p class="text-red" v-if="arrError.kpi">Số kpi không được trống</p>
        </div>
        <div class="form-group">
          <label>Tháng tính kpi<span class="text-red">(*)</span></label>
          <month-picker-input v-model="objMonthlyKpi" :months="months"></month-picker-input>
          <p class="text-red" v-if="arrError.month">Tháng tính kpi không được trống</p>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button variant="light" class="mr-2" @click="closeModal()"> Bỏ qua </b-button>
        <b-button variant="primary" @click="createKpi()"> Thêm mới </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
  import { KpiSaleOrderService } from '@/services/kpi.sale.order.service'
  import { MonthPickerInput } from 'vue-month-picker'
  import { StaffService } from '@/services/staff.service'
  import { KpiSaleConfigService } from '@/services/kpi.sale.config.service'
  import { showMess } from '@/config/utils'
  import { MerchantService } from '@/services/merchant.service'
  import { MerchantPotentialService } from '@/services/merchantPotential.service'
  import { ContractService } from '@/services/contract.service'

  export default {
    props: ['value'],
    components: {
      MonthPickerInput,
    },

    data() {
      return {
        loading: false,
        serviceTypeOption: [
          { id: 'PAYMENT', text: 'Thanh toán' },
          { id: 'SELL', text: 'Bán hàng' },
        ],
        optionRegion: [],
        serviceOption: [],
        listService: [],
        optionSaleIds: [],
        dataListMC: [],
        params: {
          typeService: '',
          service: '',
          regionId: '',
          regionName: '',
          saleId: '',
          merchantEmail: '',
          serial: '',
          contractCode: '',
          appendixCode: '',
          receiptCode: '',
          kpi: '',
          month: '',
          note: '',
        },
        objMonthlyKpi: {},
        months: [
          'Tháng 1',
          'Tháng 2',
          'Tháng 3',
          'Tháng 4',
          'Tháng 5',
          'Tháng 6',
          'Tháng 7',
          'Tháng 8',
          'Tháng 9',
          'Tháng 10',
          'Tháng 11',
          'Tháng 12',
        ],
        userData: JSON.parse(localStorage.getItem('userData')),
        messError: '',
        loadContract: false,
        loadPl: false,
        loadPT: false,
        arrError: {
          typeService: false,
          service: false,
          regionId: false,
          saleId: false,
          merchantEmail: false,
          serial: false,
          contractCode: false,
          appendixCode: false,
          receiptCode: false,
          kpi: false,
          month: false,
        },
        totalMc: 0,
        infoContract: [],
        mcSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                MerchantService.getDataMerchant({
                  limit: 10,
                  page: 1,
                  status: 'CURRENT_MERCHANT',
                  userId: JSON.parse(localStorage.getItem('userData')).userId,
                  textSearch: keySearch,
                  sort: {
                    direction: 'DESC',
                    properties: ['createdDate'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id: `${item?.customerId}-${item?.email}`,
                            text: item?.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        opitonAppendixTrans: [],
        optionAppendix: [],
        listContract: [],
        isContractId: '',
      }
    },
    async created() {
      // this.getListMerchant()
      await this.getRegions()
      await this.getListStaff()
      await this.getServiceList()
    },
    methods: {
      closeModal() {
        this.$emit('input', false)
      },
      async getDetailContract(id) {
        const parts = id.split('-')
        const beforeDash = parts[0]
        // const afterDash = parts.slice(1).join("-");
        this.loadPl = true

        try {
          this.showLoading = true
          const data = await ContractService.getDetailContractByID({
            contractId: beforeDash,
          })
          if (data.code === 1000) {
            this.opitonAppendixTrans = data.data.lstAppendixDevices.map(e => {
              return {
                id: `${e.appendixId}-${e.code}`,
                text: e.code,
              }
            })
            this.isContractId = data.data.id
            this.listContract = data.data.lstAppendixDevices
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadPl = false
        }
      },
      async getAppendix(id) {
        const parts = id.split('-')
        const beforeDash = parts[0]
        const isTb01 = this.listContract.find(e => e.appendixId === beforeDash)?.code === 'PLTB01'

        this.loadPT = true
        try {
          this.showLoading = true
          const data = await ContractService.getTranferByIDContract({
            id: isTb01 ? this.isContractId : beforeDash,
          })
          if (data.code === 1000) {
            this.optionAppendix = data.data.map(e => {
              return {
                id: e.code,
                text: e.code,
              }
            })
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadPT = false
        }
      },

      async contractInfo(id) {
        const parts = id.split('-')
        const beforeDash = parts[0]
        console.log('beforeDash', beforeDash)
        // const afterDash = parts[1];

        this.loadContract = true
        try {
          const payload = {
            limit: 100,
            page: 1,
            customerId: beforeDash,
          }
          let data = await MerchantPotentialService.getListContract(payload)
          if (data.success) {
            this.infoContract = data.data.contractList.map(e => ({
              id: `${e.id}-${e.code}`,
              text: e.code,
            }))
            if (this.totalMc > payload.limit) {
              payload.limit = this.totalMc

              data = await MerchantPotentialService.getListContract(payload)
              if (data.success) {
                this.dataListMC = data.data.contractList.map(e => ({
                  id: e.id,
                  text: e.email,
                }))
              }
            }
          }
        } catch (error) {
        } finally {
          this.loadContract = false
        }
      },
      async createKpi() {
        try {
          this.loading = true
          const valid = this.setError()
          if (!valid) {
            return false
          }
          if (
            this.objMonthlyKpi.month != '' &&
            this.objMonthlyKpi.year != '' &&
            this.objMonthlyKpi.month != undefined &&
            this.objMonthlyKpi.year != undefined
          ) {
            let monthIndex = 0
            if (parseInt(this.objMonthlyKpi.monthIndex) < 10) {
              monthIndex = '0' + this.objMonthlyKpi.monthIndex
            }
            this.params.month = monthIndex + '/' + this.objMonthlyKpi.year
          } else {
            var d = new Date()
            this.params.month = '01/' + d.getFullYear()
          }
          if (this.params.regionId != '') {
            this.optionRegion.forEach(item => {
              if (item.id == this.params.regionId) {
                this.params.regionName = item.text
              }
            })
          }

          this.params.emailSale =
            this.optionSaleIds?.find(item => item.id == this.params.saleId)?.email || ''

          const parts = this.params.merchantEmail.split('-')
          const afterDash = parts[1]
          this.params.merchantEmail = afterDash

          // Xử lý contractCode - lấy tất cả các phần sau dấu gạch ngang đầu tiên
          if (this.params.contractCode && this.params.contractCode.includes('-')) {
            const contractParts = this.params.contractCode.split('-')
            this.params.contractCode = contractParts.slice(1).join('-')
          }

          // Xử lý appendixCode - lấy phần sau dấu gạch ngang
          if (this.params.appendixCode && this.params.appendixCode.includes('-')) {
            const appendixParts = this.params.appendixCode.split('-')
            this.params.appendixCode = appendixParts[1]
          }

          // Xử lý receiptCode (nếu cũng có dạng tương tự)
          if (this.params.receiptCode && this.params.receiptCode.includes('-')) {
            const receiptParts = this.params.receiptCode.split('-')
            this.params.receiptCode = receiptParts[1]
          }

          const data = await KpiSaleOrderService.kpiCreate(this.params)
          if (data.success) {
            this.$emit('reloadData')
            this.$emit('input', false)
          } else {
            this.messError = data.message
            showMess(
              this,
              'Error',
              data.message || 'Đã có lỗi xảy ra',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (error) {
          this.messError = error
          showMess(
            this,
            'Error',
            error.data.reponse.message || error.message || 'Đã có lỗi xảy ra',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.loading = false
        }
      },
      async getListStaff() {
        try {
          this.loading = true
          if (this.userData.userId) {
            const search = {
              userId: this.userData.userId,
            }
            const data = await StaffService.getListSubordinateV3(search)
            if (data.success) {
              this.optionSaleIds = data.data.map(e => {
                return {
                  id: e.id,
                  text: `${e.name} - ${e.email}`,
                  email: e.email,
                }
              })
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // async getListMerchant() {
      //   try {
      //     this.loading = true
      //     const payload = {
      //       limit: 10,
      //       page: 1,
      //       status: 'CURRENT_MERCHANT',
      //       userId: JSON.parse(localStorage.getItem('userData')).userId
      //     }

      //     let response = await MerchantService.getDataMerchant(payload)
      //     if (response.code === 1000) {
      //       this.dataListMC = response.data.map((e) => ({
      //         id: e.id,
      //         text: e.email
      //       }))
      //       this.totalMc = response.meta.pagination.total

      //       if (this.totalMc > payload.limit) {
      //         payload.limit = this.totalMc
      //         response = await MerchantService.getDataMerchant(payload)
      //         if (response.code === 1000) {
      //           this.dataListMC = response.data.map((e) => ({
      //             id: e.id,
      //             text: e.email
      //           }))
      //         }
      //       }
      //     }
      //   } catch (error) {
      //     console.log(error)
      //   } finally {
      //     this.loading = false
      //   }
      // },
      async getRegions() {
        try {
          const data = await StaffService.getRegions()
          if (data.success) {
            this.optionRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {}
      },
      changeServiceTypeOption() {
        if (this.params.typeService != '') {
          this.serviceOption = this.listService[this.params.typeService]
        }
      },
      async getServiceList() {
        const data = await KpiSaleConfigService.getServiceList()
        if (data.success) {
          if (data.data.groupService.length > 0) {
            data.data.groupService.forEach(value => {
              if (value.service !== '' && value.detail.length > 0) {
                this.listService[value.service] = []
                value.detail.forEach(item => {
                  const tmp = { id: item.code, text: item.name }
                  this.listService[value.service].push(tmp)
                })
              }
            })
          }
        }
      },
      setError() {
        let valid = true
        delete this.params.month
        delete this.params.regionName
        for (const [key, value] of Object.entries(this.params)) {
          if (key !== 'note' && value === '') {
            this.arrError[key] = true

            valid = false
          }

          // if (key == 'merchantEmail' && value !== '') {
          //   valid = this.validEmail(value)
          //   if (!valid) {
          //     showMess(
          //       this,
          //       'Error',
          //       'Email merchant chưa đúng định dạng',
          //       'danger',
          //       'b-toaster-top-right',
          //       5 * 60 * 60
          //     )
          //   }
          // }
        }
        return valid
      },
      // validEmail(value) {
      //   const regex = new RegExp(
      //     '^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,3})$'
      //   )
      //   return regex.test(value)
      // }
    },
  }
</script>
<style scoped>
  .text-red {
    color: red;
  }
  ::v-deep .month-picker__container * {
    font-size: 14px !important;
  }
  ::v-deep .month-picker-input,
  ::v-deep .month-picker-input-container {
    width: 100% !important;
    font-size: 13px !important;
    color: #495057 !important;
  }
  ::v-deep .month-picker__container {
    z-index: 999999;
    width: 210px !important;
  }
  ::v-deep .month-picker__year button:first-child,
  ::v-deep .month-picker__year button:last-child {
    width: 25px !important;
    height: 28px !important;
  }
  ::v-deep .month-picker__year p {
    margin: 8px 0 !important;
  }
  ::v-deep .month-picker__month {
    border: 1px solid #ddd !important;
    border-radius: 0 !important;
    padding: 8px 2px !important;
    text-shadow: none;
  }
</style>
